import { Icon, Tooltip, type IconName } from "@uigovpe/components";

type Props = {
  id: string;
  icon: IconName;
  label: string;
  value: number;
  tooltip?: string;
  onClick?: () => void;
};

export default function PerformanceMetricCard({
  id,
  icon,
  label,
  value,
  tooltip,
  onClick,
}: Props) {
  return (
    <div className="min-w-0!">
      <button
        id={id}
        type="button"
        onClick={onClick}
        className="flex! h-full! min-h-24! w-full! cursor-pointer! flex-col! rounded-xl! border-0! border-l-2! border-[#4e3873]! bg-white! p-3! text-left! shadow-md! transition-transform! hover:-translate-y-0.5! focus-visible:outline-2! focus-visible:outline-offset-2! focus-visible:outline-[#4e3873]!"
        aria-label={`${label}: ${value}. Abrir detalhes`}
      >
        <Icon
          icon={icon}
          outline
          className="mb-2! text-[16px]! text-[#4e3873]!"
        />
        <span className="my-2! text-[12px]! leading-4! font-semibold! text-[#494c57]!">
          {label}
        </span>
        <strong className="mt-auto! text-[14px]! text-[#4e3873]!">
          {value}
        </strong>
      </button>
      {tooltip && (
        <Tooltip
          target={`#${id}`}
          theme="light"
          position="mouse"
          mouseTrack
          mouseTrackTop={12}
          mouseTrackLeft={12}
          content={<span>{tooltip}</span>}
        />
      )}
    </div>
  );
}
